module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gl0D6"))).then(() => parcelRequire('ljYL6'));